import React,{PureComponent} from 'react';

import './auth-app.css';
import Button from 'components/Button';

export default class AuthAppView extends PureComponent{
    render(){
        return(
            <div className="auth-app">
                <p>{`Logged in as: ${this.props.user}`}</p>
                <div className="app-intro">
                    <img src={this.props.authApp.logoUrl} alt="Logo" className="app-logo"/>
                    <h2>{this.props.authApp.name}</h2>
                </div>
                <p>This app wants access to:</p>
                <div className="access-box">
                    {this.props.authApp.access.map((app,i)=><p key={i}>{app}</p>)}
                </div>
                <div className="button-container">
                    <div className="auth-button"><Button onClick={this.props.onAuthoriseApp} styling="apps-primary">Authorise</Button></div>
                    <div className="auth-button"><Button onClick={this.props.onCancel} styling="apps-primary">Cancel</Button></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AuthApp/AuthAppView.js